"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformJSONToAsset = exports.transformAssetToJSON = void 0;

require("core-js/modules/es.array.map.js");

var _assetContent = require("./asset-content");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformAssetToJSON = function transformAssetToJSON(value) {
  return {
    layer_source_id: value.layerSourceId,
    display_name: value.displayName,
    layer_name: value.layerName,
    contents: value.contents.map(_assetContent.transformAssetContentToJSON)
  };
};

exports.transformAssetToJSON = transformAssetToJSON;

var transformJSONToAsset = function transformJSONToAsset(value) {
  return {
    layerSourceId: value.layer_source_id,
    displayName: value.display_name,
    layerName: value.layer_name,
    contents: value.contents.map(_assetContent.transformJSONToAssetContent)
  };
};
/**
 * Assets are automatically generated while exporting designs based on the platform the design is exported. Asset formats and densities change according to these platforms.  Platform | Formats ---|---|--- Base | PNG (1.0, 1.5, 2.0, 3.0, 4.0), and PDF Web | PNG (1.0, 2.0, 3.0), SVG, and JPG (bitmap image) iOS | PNG (1.0, 2.0, 3.0), and PDF Android | PNG (1.0, 1.5, 2.0, 3.0, 4.0), and SVG 
 * @export
 * @interface Asset
 */


exports.transformJSONToAsset = transformJSONToAsset;